import Nadeln from "./acupuncture.png";

export default function Akupunkturnadeln() {
    return <img width={100} height={100} src={Nadeln} alt="Akupunkturnadeln"/>
}